export default {
  border_radius: '0',
  border_width: '1rem',
  fixed_height: '3.75rem',
  font_weight: '400',
  font_size: '1.125rem',
  new_tab_width: '0.75rem',
  new_tab_margin: {
    left: '0.3125rem',
  },
  padding: {
    vertical: '0.625rem',
    horizontal: '0.9375rem',
  },
  underline_height: '0.125rem',
  underline_margin: '0.125rem',
  zoom_font_size: '1.25rem',
};
